import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
const ConfigSelect = ({
  value,
  setValue,
  optionsMap,
  customStyle,
  activeColor,
  isDisabled,
  freeDataKey,
}: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  optionsMap: { [index: string]: string };
  customStyle?: any;
  activeColor: string;
  isDisabled?: boolean;
  freeDataKey?: string;
}) => (
  <FormControl variant="standard" sx={{ m: 0, minWidth: 120 }}>
    <Select
      value={value}
      onChange={event => {
        if (!isDisabled) {
          setValue(event.target.value);
        }
      }}
      MenuProps={{
        autoFocus: false,
      }}
      sx={{
        fontWeight: 500,
        paddingTop: 0,
        '& #demo-simple-select-standard': {
          paddingTop: '0px !important',
          paddingLeft: '5px',
        },
        '& .MuiSelect-standard': {
          paddingTop: '0px !important',
          backgroundColor: 'transparent',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          outline: 'none',
        },
        fieldset: {
          border: 'none !important',
          outline: 'none',
        },
        ...customStyle,
      }}
      renderValue={selected => (
        <Typography variant="body1" sx={{ fontWeight: 500, color: activeColor }}>
          {optionsMap[selected]}
        </Typography>
      )}
    >
      {Object.keys(optionsMap).map(option => (
        <MenuItem value={option} disabled={isDisabled && option !== freeDataKey}>
          {optionsMap[option]}
          {isDisabled && option !== freeDataKey && <LockIcon color="primary" />}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default ConfigSelect;
